export default "__VITE_ASSET__pKoUohIw__";